import { r as s, h as t } from "./index-6e735f92.js";
import "react";
import "react/jsx-runtime";
import "react-dom";
const e = ".sc-play-icon-h{display:flex}", i = e, r = class {
  constructor(o) {
    s(this, o), this.width = "15", this.height = "15";
  }
  render() {
    return t("svg", { key: "bd7e6c0150dac4f37e144c9750140dd990612a40", width: this.width, height: this.height, viewBox: "0 0 24 24", fill: "auto", xmlns: "http://www.w3.org/2000/svg" }, t("path", { key: "785ae52fc510f9d7a9a478027c7e392580134425", d: "M21 12L3 21V3L21 12Z", stroke: "auto", "stroke-width": "1.5", "stroke-linecap": "round", "stroke-linejoin": "round" }));
  }
};
r.style = i;
export {
  r as play_icon
};
